export const TITLE = 'TITLE';
export const HEADER_Z_INDEX = 'HEADER_Z_INDEX'
export const NAV_TOGGLE = 'NAV_TOGGLE'
export const NAV_TRIGGER_FOCUS = 'NAV_TRIGGER_FOCUS'
export const REPORT_MENU = 'REPORT_MENU'
export const REPORT_MENU_RESET = 'REPORT_MENU_RESET'
export const REPORT_LINK = 'REPORT_LINK'
export const REPORT_TICKET = 'REPORT_TICKET'
export const PAGE_RESET = 'PAGE_RESET'